import { PRODUCTION } from '@/store/constants';

import mixpanel from 'mixpanel-browser';

export const trackEvent = (event, data = {}) => {
    const area = data.area;
    const section = data.section;
    if (area && section) {
        event = `${area} (${section}): ${event}`;
    }

    if (PRODUCTION) {
        mixpanel.track(event, data);
    } else {
        console.log(event, data);
    }
};